import { ICoords } from "../../redux/modules/flightMarkers/flightMarkersReducer";
import { ISRS } from "../../apiFacades/csu/site";

export const convertGlobalToLocalCoords = (
  globalCoords: ICoords,
  srs: ISRS,
) => {
  if (!srs.isAssumed) {
    return globalCoords;
  }

  const [a1, b1, c1, a2, b2, c2] =
    srs.assumedSrs.translationMatrixToIntermediateSrs;
  const { x, y, z } = globalCoords;

  const yLocal = (a1 * (c2 - y) + a2 * (x - c1)) / (a2 * b1 - a1 * b2);
  const xLocal = (x - b1 * yLocal - c1) / a1;

  return {
    x: xLocal,
    y: yLocal,
    z,
  };
};
